"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const hauling_statistic_types_1 = require("./hauling-statistic.types");
const moment_1 = __importDefault(require("moment"));
const initialState = {
    isError: false,
    isLoading: true,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    mutationMode: false,
    isLoadingExport: false,
    documentExport: {
        content: '',
        filename: '',
        filetype: '',
    },
    dataItem: {
        id: '',
        ticket_no_silo: '',
        ticket_no_hopper: '',
        ticket_no: '',
        contractor_id: '',
        contractor_name: '',
        contractor_code: '',
        brand_id: '',
        brand_code: '',
        brand_name: '',
        brand_color: '',
        hauler_id: '',
        hauler_no: '',
        hauler_rfid_tag: '',
        vessel_1_id: '',
        vessel_1_no: '',
        vessel_1_capacity: '',
        vessel_2_id: '',
        vessel_2_no: '',
        vessel_2_capacity: '',
        driver_id: '',
        driver_name: '',
        checkpoint_id_hopper: '',
        checkpoint_name_hopper: '',
        transaction_silo_id: '',
        main_entrance_in_hopper: '',
        time_in_hopper: '',
        time_out_hopper: '',
        queue_time_hopper: '',
        lead_time_hopper: '',
        transaction_type_hopper: '',
        is_active_hopper: '',
        checkpoint_id_silo: '',
        checkpoint_name_silo: '',
        main_entrance_in_silo: new Date(),
        time_in_silo: new Date(),
        time_out_silo: new Date(),
        queue_time_silo: '',
        lead_time_silo: '',
        transaction_type_silo: '',
        is_active_silo: '',
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date(),
        dumping_type_id: '',
        dumping_type: ''
    },
    start_date: (0, moment_1.default)().format('YYYY-MM-DD'),
    end_date: (0, moment_1.default)().format('YYYY-MM-DD'),
    dataStates: {
        sortable: false,
        filterable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'time_in_silo', dir: 'desc' }]
    }
};
const haulingStatisticReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [hauling_statistic_types_1.haulingStatisticTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [hauling_statistic_types_1.haulingStatisticTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [hauling_statistic_types_1.haulingStatisticTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoadingExport } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, isLoadingExport: isLoadingExport ? isLoadingExport : initialState.isLoadingExport });
    },
    [hauling_statistic_types_1.haulingStatisticTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [hauling_statistic_types_1.haulingStatisticTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false, isLoadingExport: false });
    },
    [hauling_statistic_types_1.haulingStatisticTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload }) });
    },
    [hauling_statistic_types_1.haulingStatisticTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [hauling_statistic_types_1.haulingStatisticTypes.SET_EXPORT_DOCUMENTS_URL]: (state, action) => {
        const { name, type, content } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, isLoadingExport: false, documentExport: {
                content: content,
                filename: name,
                filetype: type,
            } });
    },
    [hauling_statistic_types_1.haulingStatisticTypes.CLEAR_EXPORT_DOCUMENTS_URL]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, documentExport: {
                content: '',
                filename: '',
                filetype: '',
            } });
    },
    [hauling_statistic_types_1.haulingStatisticTypes.ON_DATE_CHANGE]: (state, action) => {
        const { start_date, end_date } = action.payload;
        return Object.assign(Object.assign({}, state), { start_date, end_date: end_date ? end_date : (0, moment_1.default)().format('YYYY-MM-DD'), isLoading: true });
    },
});
exports.default = haulingStatisticReducer;
